import * as tmi from "@/constants";

/**
 * Returns a boolean defining whether the short codes that allow public (free) access exists within
 * the shortCodes formal parameter passed into the function.
 *
 * @param { string | string[] | null | undefined } stringOrStringsToMatch - A non-descriptive string against which to check
 *      for 'true-market-insiders' or 'true market insiders'.
 * @returns {boolean} True if the shortCode parameter passed contains one of the free short codes, false otherwise.
 */
export function isFreelyAvailableContent( stringOrStringsToMatch: string | string[] | null | undefined ): boolean {
    if ( null == stringOrStringsToMatch ) {
        return false;
    }

    let normalizedString: string;
    if ( Array.isArray( stringOrStringsToMatch ) ) {
        normalizedString = stringOrStringsToMatch.join( '|' ).toLowerCase();
    } else {
        normalizedString = stringOrStringsToMatch.toLowerCase();
    }

    return normalizedString.includes( tmi.TmiPublicContentPermissionKey ) || normalizedString.includes( tmi.TmiPublicContentNonHyphenated );
}
